import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TicketCounterSvg } from '../../common/svg/AllSvg';

const TicketCounter = () => {
	const [data, setData] = useState<any[]>([])
	const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
	const { t } = useTranslation('common');

	useEffect(() => {
		if (!!stationDetailData) {
			setData(stationDetailData?.ticket_counters)
		}
	}, [stationDetailData])

	return (
		<>
			{/* Ticket Counters section */}
			<div className="flex flex-col container pt-[30px] xlx:pt-[40px]" id="ticket_counters">
				<div className="flex items-center gap-[9px]">
					<TicketCounterSvg />
					<h5 className='font-bold text-[#1E58A6] uppercase'>{t('passenger.station_detail.ticket_counters')}</h5>
				</div>
				<div className="mt-[25px] w-full max-md:max-w-full">
					<div className="grid grid-cols-1 xsm:grid-cols-2 mms:grid-cols-3 xl:grid-cols-4 gap-[20px]">
						{Array.isArray(data) && data?.map((item: any, index: number) => (
							<div key={index} className="border border-[#059db280] dark:border-[#ffffff80] p-[15px] xlx:p-[22px] flex flex-col gap-[20px] rounded-[15px] min-h-[95px] xlx:min-h-[105px] justify-between">
								<h4 className='text-primaryText dark:text-white font-semibold'>{item?.ticket_counter_name}</h4>
								<h6 className='text-blackDull dark:text-textBlackDull font-medium'>
									{item?.location}
								</h6>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default TicketCounter;